import {geolocateControl, setMapLocation} from './map';
import {addressSearchInput, addressSearchNumbers} from './search-box';

const myLocationButton = document.getElementById('my-location');

export let userPosition = null;

export function initGeoLocation() {
  if ('geolocation' in navigator) {
    myLocationButton.addEventListener('click', handleClick);
  } else {
    myLocationButton.setAttribute('disabled', 'true');
  }
}

function setLoadingState(isLoading) {
  if (isLoading) {
    myLocationButton.classList.add('is-loading');
  } else {
    myLocationButton.classList.remove('is-loading');
  }
}

function handleClick(event) {
  event.preventDefault();

  geolocateControl.trigger();

  if (myLocationButton.classList.contains('active')) {
    myLocationButton.classList.remove('active');
    addressSearchInput.disabled = false;
    addressSearchNumbers.disabled = false;
  } else {
    myLocationButton.classList.add('active');
    addressSearchInput.disabled = true;
    addressSearchNumbers.disabled = true;
  }

  // setTimeout(() => {}, 1000);

  // navigator.geolocation.getCurrentPosition(position => {
  //   setLoadingState(false);

  //   if (position.coords) {
  //     console.log(position);
  //     userPosition = position;
  //     setMapLocation(position.coords.latitude, position.coords.longitude);
  //   } else {
  //     console.warn('No GPS');
  //   }
  // });
}
